import { CommonModule } from "@angular/common";
import {
  ChangeDetectorRef,
  Component,
  OnDestroy,
  TemplateRef,
  ViewChild,
} from "@angular/core";
import { ReactiveFormsModule, FormsModule, FormControl, FormGroup, FormBuilder } from "@angular/forms";
import { MatButtonModule } from "@angular/material/button";
import { MatOptionModule } from "@angular/material/core";
import {
  MatDialog,
  MatDialogModule,
  MatDialogRef,
} from "@angular/material/dialog";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatIcon } from "@angular/material/icon";
import { MatInputModule } from "@angular/material/input";
import { MatMenuModule } from "@angular/material/menu";
import {
  MatPaginatorModule,
  MatPaginatorIntl,
  PageEvent,
} from "@angular/material/paginator";
import { MatSelectModule } from "@angular/material/select";
import { MatSidenavContainer } from "@angular/material/sidenav";
import { MatSlideToggle } from "@angular/material/slide-toggle";
import { MatSnackBar } from "@angular/material/snack-bar";
import { MatSortModule } from "@angular/material/sort";
import { MatTableDataSource, MatTableModule } from "@angular/material/table";
import { IPaginationResult } from "app/common/interfaces";
import { CustomMatPaginatorIntl } from "app/mock-api/common/customPaginatorIntl";
import { MaterialListService } from "./material-list.service";
import MaterialListAttributes from "@albatrosdeveloper/ave-models-package/lib/schemas/materials/material-list/material-list.entity";
import { MaterialAttributes } from "@albatrosdeveloper/ave-models-package/lib";
import { debounceTime, distinctUntilChanged, Subject, Subscription } from "rxjs";
import { environment } from "environments/environment.prod";
import { MaterialService } from "../material/material.service";
import { NgxMatSelectSearchModule } from "ngx-mat-select-search";
import { ExportService } from "app/layout/export-overlay/export-overlay.service";
import { ExportDialogComponent } from 'app/layout/export-overlay/dialog/export-dialog.component';
import { ExportOptions } from "app/layout/export-overlay/tasks/core/export-task.interfaces";
import { AddBusinessPartnerOrderComponent } from "../../business-partners/business-partner/business-partner-order-modal/business-partner-order.component";
import { MaterialListDeliveryWindowService } from "./material-list-delivery-window.service";
import orderDeliveryWindowsAttributes from "@albatrosdeveloper/ave-models-package/lib/schemas/routing/sub-route/sub-route-delivery-windows/order-delivery-windows.entity";
import { MaterialListExport } from "./exports/material-list.export";
import { MATERIAL_LIST_TITLE } from "./exports/material-list.constants";
import { SearchService } from "app/layout/common/search-page/search-page.service";
import { IFilters } from "../../filters/interfaces/filterInterface";
import { FilterComponent } from "app/common/components/filter/filter.component";
import { ConfigurationFiltersComponent } from "../../filters/configuration-filters/configuration-filters.component";
import { MaterialsManagementFiltersComponent } from "../../filters/materials-management-filters/materials-management-filters.component";
import { StatusFiltersComponent } from "../../filters/status-filters/status-filters.component";
import { HoverMenuDirective } from "@fuse/directives/hover-menu/hover-menu.directive";
import { NoFiltersAvailableComponent } from "app/common/components/no-filters-available/no-filters-available.component";




@Component({
  selector: "app-material-list",
  standalone: true,
  imports: [
    CommonModule,
    MatSidenavContainer,
    MatTableModule,
    MatSortModule,
    MatPaginatorModule,
    MatSlideToggle,
    MatIcon,
    MatButtonModule,
    MatMenuModule,
    MatDialogModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    FormsModule,
    MatInputModule,
    MatSelectModule,
    MatOptionModule,
    NgxMatSelectSearchModule,
    FilterComponent,
    StatusFiltersComponent,
    ConfigurationFiltersComponent,
    MaterialsManagementFiltersComponent,
    HoverMenuDirective,
    NoFiltersAvailableComponent
  ],
  providers: [{ provide: MatPaginatorIntl, useClass: CustomMatPaginatorIntl },
    MaterialListExport
  ],
  templateUrl: "./material-list.component.html",
  styleUrl: "./material-list.component.scss",
})
export class MaterialListComponent implements OnDestroy {
  displayedColumns: string[] = ["name", "statusId", "action"];

  displayedColumnsOrder: string[] = [
    "days",
    "hourStart",
    "hourEnd",
    "numberOfHoursToDelivery",
    "status",
    "actions",
  ];

  dataSource = new MatTableDataSource<MaterialListAttributes>([]);

  totalItems = 0;
  search: string = "";
  pageSize = 50;
  pageIndex: number = 1;
  sortActive: keyof MaterialListAttributes = "name";
  sortDirection: "ASC" | "DESC" = "ASC";

  fileToUpload: File;
  aux_file = false;

  currentCreateListMaterial: MaterialListAttributes =
    this.initializeCreateMaterialList(); //TODO INTERFAZ
  currentUpdateListMaterial: MaterialListAttributes | undefined;

  @ViewChild("addModal") addModal!: TemplateRef<any>;
  @ViewChild("editModal") editModal!: TemplateRef<any>;
  @ViewChild("deleteDialog") deleteDialog!: TemplateRef<any>;
  @ViewChild("deliveryModal") deliveryModal!: TemplateRef<any>;
  @ViewChild("deleteModalOrder") deleteModalOrder!: TemplateRef<any>;

  dialogRefAdd: MatDialogRef<any>;
  dialogRefEdit: MatDialogRef<any>;

  //productos
  materialList: MaterialAttributes[] = [];
  searchMaterial = "";
  private searchSubject = new Subject<string>();

  displayedColumnsItem: string[] = ["code", "name", "action"];

  dataSourceItem = new MatTableDataSource<MaterialAttributes>([]);

  totalItemsItem = 0;
  searchItem: string = "";
  searchItemControl = new FormControl();
  pageSizeItem = 50;
  pageIndexItem: number = 1;
  sortActiveItem: keyof MaterialListAttributes = "name";
  sortDirectionItem: "ASC" | "DESC" = "ASC";

  daysList: { day: string; value: number }[] = [
    { day: "Lunes", value: 1 },
    { day: "Martes", value: 2 },
    { day: "Miércoles", value: 3 },
    { day: "Jueves", value: 4 },
    { day: "Viernes", value: 5 },
    { day: "Sábado", value: 6 },
    { day: "Domingo", value: 7 },
  ];

  //BUSCADOR
  searchSubscription: Subscription;

  selectedStatuses: [] = [];
  form: FormGroup;

  constructor(
    private readonly materialListService: MaterialListService,
    private readonly materialService: MaterialService,
    private readonly materialListDeliveryWindowService: MaterialListDeliveryWindowService,
    private readonly searchService: SearchService,
    private dialog: MatDialog,
    private snackBar: MatSnackBar,
    private cdr: ChangeDetectorRef,
    public exportService: ExportService,
    private materialListExport: MaterialListExport,
    private fb: FormBuilder
  ) {
    this.form = this.fb.group({
      companyId: [],
    });
  }

  ngAfterViewInit(): void {
    this.onHandleSearch();
    this.getList();
    this.searchItemControl.valueChanges
      .pipe(
        debounceTime(500),
        distinctUntilChanged()
      )
      .subscribe((filterValue: string) => {
        this.pageIndexItem = 1
        this.searchItem = filterValue
        this.getTableMaterial();
    });
  }

  applyFilter(filterValue: string) {
    this.pageIndex = 1;
    this.search = filterValue;
    this.getList();
  }

  public onHandleSearch(){
    this.searchSubscription = this.searchService.searchTerm$
      .subscribe(term => {
          this.pageIndex = 1;
          this.search = term;
          this.getList();
      });
  }

  clearFilters(): void {
    this.form = this.fb.group({
      companyId: [],
    });
    this.getList();
  }

  getList(): void {
    let options = {
      currentPage: this.pageIndex,
      limitPerPage: this.pageSize,
      search: this.search,
      sort: this.sortActive,
      sortDirection: this.sortDirection,
    };

    let dataFilter: IFilters = {
      companyId: this.form.get("companyId")?.value,
      status: this.selectedStatuses ? this.selectedStatuses : null,
    }

    this.materialListService.findAllWithCount(options, dataFilter).subscribe({
      next: (res: IPaginationResult<MaterialListAttributes>) => {
        this.dataSource.data = res?.data?.[0]?.data ?? [];
        this.totalItems = res?.data?.[0]?.pageInfo?.[0]?.total ?? 0;
      },
      error: (err) => {
        this.snackBar.open(
          err.error.message || "Error al obtener tipos de pago",
          "Cerrar",
          { duration: 5000 }
        );
      },
    });
  }

  changeSort(e) {
    this.sortActive = e.active;
    this.sortDirection = e.direction;
    this.getList();
  }

  changePage(e: PageEvent) {
    this.pageIndex = e.pageIndex + 1;
    this.pageSize = e.pageSize;
    this.getList();
  }

  private initializeCreateMaterialList(): MaterialListAttributes {
    //ICreateMaterialList
    return {
      code: "",
      name: "",
    };
  }

  openCreateModal(): void {
    this.currentCreateListMaterial = this.initializeCreateMaterialList();
    this.dialogRefAdd = this.dialog.open(this.addModal, {
      width: "90%",
      disableClose: true,
    });
    this.dialogRefAdd.afterClosed().subscribe((result) => {
      result;
    });
  }

  openEditModal(materialList: MaterialListAttributes): void {
    this.setupMaterialSearchControl();
    this.getMaterialList();

    this.currentUpdateListMaterial = {
      ...materialList,
    };

    this.getTableMaterial();

    this.dialogRefEdit = this.dialog.open(this.editModal, {
      width: "90%",
      disableClose: true,
    });
    this.dialogRefEdit.afterClosed().subscribe((result) => result);
  }

  private getMaterialList(): void {
    let sortDirectionItem: "ASC" | "DESC" = "ASC";

    const materialOptions = {
      search: this.searchMaterial,
      currentPage: 1,
      limitPerPage: 50,
      sortActive: "name",
      sortDirection: sortDirectionItem,
    };

    const companyCodes = environment.companyId;
    //TODO FILTER
    let filter : IFilters = {
      companyId: companyCodes
    }

    this.materialService
      .findAllWithCount(materialOptions, filter, true)
      .subscribe({
        next: (res: IPaginationResult<MaterialAttributes>) => {
          this.materialList = res?.data?.[0]?.data ?? [];
        },
        error: (err) => {
          this.snackBar.open(err.error.message || "Error al obtener materiales.","Cerrar",{ duration: 5000});
        },
      });
  }

  changueOptionsMaterial(event) {
    this.searchSubject.next(event);
  }

  private setupMaterialSearchControl(): void {
    this.searchSubject
      .pipe(debounceTime(500), distinctUntilChanged())
      .subscribe((searchTerm) => {
        if (searchTerm) {
          this.searchMaterial = searchTerm;
          this.getMaterialList();
        }
      });
  }

  getTableMaterial(): void {
    if (!this.currentUpdateListMaterial.code) {
      return;
    }

    let options = {
      currentPage: this.pageIndexItem,
      limitPerPage: this.pageSizeItem,
      search: this.searchItem,
      sort: this.sortActiveItem as keyof MaterialAttributes,
      sortDirection: this.sortDirectionItem,
    };

    this.materialService
      .findAllWithCountShort(options, this.currentUpdateListMaterial.code)
      .subscribe({
        next: (res: IPaginationResult<any>) => {
          this.dataSourceItem.data = res?.data?.[0]?.data ?? [];
          this.totalItemsItem = res?.data?.[0]?.pageInfo?.[0]?.total ?? 0;
        },
        error: (err) => {
          this.snackBar.open(
            err.error.message || "Error al obtener materiales",
            "Cerrar",
            { duration: 5000 }
          );
        },
      });
  }

  changeSortDetail(e) {
    this.sortActiveItem = e.active;
    this.sortDirectionItem = e.direction?.toUpperCase() || "ASC";
    this.getTableMaterial();
  }

  changePageDetail(e: PageEvent) {
    this.pageIndexItem = e.pageIndex + 1;
    this.pageSizeItem = e.pageSize;
    this.getTableMaterial();
  }

  addMaterialList() {
    /* let auxData = this.dataSourceItem.data.slice();
    auxData.push((this.currentUpdateListMaterial as any).itemId);

    this.dataSourceItem.data = auxData;
    this.totalItemsItem = this.totalItemsItem + 1;

    (this.currentUpdateListMaterial as any).itemId = null; */

    this.saveDetailOnlyMaterial(String(this.currentUpdateListMaterial._id), (this.currentUpdateListMaterial as any).itemId)
  }

  openDeleteItemDialog(
    index: number,
    materialList: MaterialListAttributes
  ): void {
    this.dialog
      .open(this.deleteDialog, {
        data: materialList,
        panelClass: "delete-modal",
        disableClose: true,
      })
      .afterClosed()
      .subscribe(
        (result) => result && this.deleteConditional(materialList, index)
      );
  }

  deleteConditional(materialList, index) {
    if (materialList.materialList) {
      this.deleteServiceItem(String(materialList._id), index);
    } else {
      this.deleteItem(index);
    }
  }

  deleteItem(i: number): void {
    let auxData = this.dataSourceItem.data.slice();
    auxData.splice(i, 1);
    this.dataSourceItem.data = auxData;
    this.totalItemsItem = this.totalItemsItem - 1;
    //this.snackBar.open('Registro eliminado con éxito', 'Cerrar', { duration: 3000 });
    this.cdr.detectChanges();
  }

  deleteServiceItem(id, index): void {
    this.materialService.deleteListMaterial(id).subscribe({
      next: () => {
        this.snackBar.open("Registro eliminado con éxito", "Cerrar", {
          duration: 3000,
        });
        this.deleteItem(index);
        //this.getTableMaterial()
      },
      error: (err) => {
        this.snackBar.open(
          err.error.message || "Error al actualizar el registro",
          "Cerrar",
          { duration: 3000 }
        );
      },
    });
  }

  createMaterialList(): void {
    this.materialListService.create(this.currentCreateListMaterial).subscribe({
      next: () => {
        this.snackBar.open("Registro creado con éxito", "Cerrar", {
          duration: 3000,
        });
        if (this.dialogRefAdd) {
          this.dialogRefAdd.close(true);
        }
        this.getList();
      },
      error: (err) => {
        this.snackBar.open(
          err.error.message || "Error al crear el registro",
          "Cerrar",
          { duration: 3000 }
        );
      },
    });
  }

  updateMaterialList(id: string): void {
    if (this.currentUpdateListMaterial) {
      const updatedPaymentType: MaterialListAttributes = {
        ...this.currentUpdateListMaterial,
      };

      this.materialListService.update(id, updatedPaymentType).subscribe({
        next: () => {
          this.snackBar.open("Registro actualizado con éxito", "Cerrar", {
            duration: 3000,
          });
          if (this.dialogRefEdit) {
            this.dialogRefEdit.close(true);
          }
          //this.saveDetailMaterial(updatedPaymentType._id); //comentado porque es global y como es paginado no funcionara.
          this.getList();
        },
        error: (err) => {
          this.snackBar.open(
            err.error.message || "Error al actualizar el registro",
            "Cerrar",
            { duration: 3000 }
          );
        },
      });
    }
  }

  saveDetailOnlyMaterial(id: string, material: MaterialAttributes): void {
    if(!material){
      return;
    }

    let send = {
      materialIds: [material._id],
    };

    this.materialService.saveListMaterial(id, send).subscribe({
      next: () => {
        (this.currentUpdateListMaterial as any).itemId = null
        this.getMaterialList();
        this.getTableMaterial();
      },
      error: (err) => {
        this.snackBar.open(
          err.error.message || "Error al actualizar el registro",
          "Cerrar",
          { duration: 3000 }
        );
      },
    });
  }

  saveDetailMaterial(id) {
    if (this.dataSourceItem.data.length == 0) {
      return;
    }

    let send = {
      materialIds: this.dataSourceItem.data.map((e) => e._id),
    };

    this.materialService.saveListMaterial(id, send).subscribe({
      next: () => {
        this.snackBar.open("Registro actualizado con éxito", "Cerrar", {
          duration: 3000,
        });
        if (this.dialogRefEdit) {
          this.dialogRefEdit.close(true);
        }
      },
      error: (err) => {
        this.snackBar.open(
          err.error.message || "Error al actualizar el registro",
          "Cerrar",
          { duration: 3000 }
        );
      },
    });
  }

  onStatusChange(event: boolean, materialList: MaterialListAttributes): void {
    const originalStatusId = materialList.statusId;
    const updatedStatusId = event ? 1 : 0;
    const updatedmaterialList = { ...materialList, statusId: updatedStatusId };

    this.materialListService
      .update(materialList._id.toString(), updatedmaterialList)
      .subscribe({
        next: () => {
          this.getList();
        },
        error: () => {
          materialList.statusId = originalStatusId; // Volver al estado original si falla
          this.snackBar.open("Error al actualizar el estado.", "Cerrar", {
            duration: 3000,
          });
          this.getList();
        },
      });
  }

  openDeleteDialog(materialList: MaterialListAttributes): void {
    this.dialog
      .open(this.deleteDialog, {
        data: materialList,
        panelClass: "delete-modal",
        disableClose: true,
      })
      .afterClosed()
      .subscribe(
        (result) => result && this.delete(materialList._id.toString())
      );
  }

  delete(id: string): void {
    //this.materialListService.remove(id).subscribe(() => {
    this.materialService.deleteAllListMaterial(id).subscribe(() => {
      this.getList();
      this.snackBar.open("Registro eliminado con éxito", "Cerrar", {
        duration: 3000,
      });
    });
  }


  
  downloadSubRouteTemplate() {
    const url = this.materialListService.getFileTemplateMaterialList();
    if (!url) {
      this.snackBar.open("Plantilla no disponible.", "Cerrar", {
        duration: 3000,
      });
      return;
    }
    window.open(url);
  }

  
  async handleFileInput(event) {
    this.aux_file = true;
    this.fileToUpload = event.target.files[0];
    if (this.fileToUpload) {
      if (
        this.fileToUpload.type !=
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
      ) {
        this.snackBar.open("Ingrese solo de tipo .xlsx", "Cerrar", {
          duration: 3000,
        });
      }
    } else {
      this.aux_file = false;
    }
  }

  onMessageConfirm() {
    if (this.fileToUpload) {
      let send = {
        file: this.fileToUpload,
      };

      //formdata
      let formdata = new FormData();
      for (let key in send) {
        formdata.append(key, send[key]);
      }

      this.materialListService.importFile(formdata).subscribe({
        next: (res: any) => {
          this.snackBar.open(res.message, "Cerrar", { duration: 3000 });
          this.aux_file = false;
          this.getList();
        },
        error: (err) => {
          this.aux_file = false;
          this.snackBar.open(
            err.error.message || "Error al subir el registro",
            "Cerrar",
            { duration: 3000 }
          );
        },
      });
    }
  }

  openOrderModal(materialList: MaterialListAttributes): void {
    this.currentUpdateListMaterial = {
      ...materialList,
    };
    this.dialog
      .open(this.deliveryModal, {
        panelClass: "form-modal",
        disableClose: true,
      })
      .afterClosed()
      .subscribe((result) => {});
  }

  openAddOrderModal(existingData?) {
    const dialogRef = this.dialog.open(AddBusinessPartnerOrderComponent, {
      panelClass: ".form-modal",
      data: existingData,
      disableClose: true,
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        if (existingData) {
          this.updateOrderDeliveryWindow(result);
        } else {
          this.createOrderDeliveryWindow(result);
        }
      }
    });
  }

  createOrderDeliveryWindow(result): void {
    this.materialListDeliveryWindowService
      .createEmbedded(this.currentUpdateListMaterial._id.toString(), result)
      .subscribe({
        next: () => {
          this.snackBar.open("Orden creada con éxito", "Cerrar", {
            duration: 3000,
          });
          this.materialListDeliveryWindowService
            .findByMaterialListId(this.currentUpdateListMaterial._id.toString())
            .subscribe((data) => {
              this.currentUpdateListMaterial.orderDeliveryWindows = data?.data;
            });
        },
        error: (err) => {
          this.snackBar.open(
            err.error.message ||
              "Error al crear la ventana horaria de entrega.",
            "Cerrar",
            { duration: 3000 }
          );
        },
      });
  }

  updateOrderDeliveryWindow(result: any): void {
    this.materialListDeliveryWindowService
      .updateEmbedded(
        this.currentUpdateListMaterial._id.toString(),
        result._id.toString(),
        result
      )
      .subscribe({
        next: () => {
          this.snackBar.open(
            "Ventana horaria de entrega actualizada con éxito.",
            "Cerrar",
            {
              duration: 3000,
            }
          );
          this.materialListDeliveryWindowService
            .findByMaterialListId(this.currentUpdateListMaterial._id.toString())
            .subscribe((data) => {
              this.currentUpdateListMaterial.orderDeliveryWindows = data?.data;
            });
        },
        error: (err) => {
          this.snackBar.open(
            err.error.message ||
              "Error al actualizar la ventana horaria de entrega.",
            "Cerrar",
            { duration: 3000 }
          );
        },
      });
  }

  onStatusOrderChange(
    event: boolean,
    order: orderDeliveryWindowsAttributes
  ): void {
    const originalStatusId = order.statusId;
    const updatedStatusId = event ? 1 : 0;
    const updatedFrequency: any = {
      ...order,
      statusId: updatedStatusId,
    };
    this.materialListDeliveryWindowService
      .updateEmbedded(
        this.currentUpdateListMaterial._id.toString(),
        order._id.toString(),
        updatedFrequency
      )
      .subscribe({
        next: () => {
          this.materialListDeliveryWindowService
            .findByMaterialListId(this.currentUpdateListMaterial._id.toString())
            .subscribe((data) => {
              this.currentUpdateListMaterial.orderDeliveryWindows = data?.data;
            });
        },
        error: () => {
          order.statusId = originalStatusId;
          this.snackBar.open("Error al actualizar el estado.", "Cerrar", {
            duration: 3000,
          });
          this.materialListDeliveryWindowService
            .findByMaterialListId(this.currentUpdateListMaterial._id.toString())
            .subscribe((data) => {
              this.currentUpdateListMaterial.orderDeliveryWindows = data?.data;
            });
        },
      });
  }

  openDeleteOrder(order: orderDeliveryWindowsAttributes): void {
    this.dialog
      .open(this.deleteModalOrder, { data: order, panelClass: "delete-modal" })
      .afterClosed()
      .subscribe((result) => result && this.deleteOrder(order._id.toString()));
  }

  deleteOrder(id: string): void {
    this.materialListDeliveryWindowService
      .deleteEmbedded(this.currentUpdateListMaterial._id.toString(), id, null)
      .subscribe(() => {
        this.snackBar.open(
          "Ventana horaria de entrega eliminada con éxit.",
          "Cerrar",
          {
            duration: 3000,
          }
        );
        this.materialListDeliveryWindowService
          .findByMaterialListId(this.currentUpdateListMaterial._id.toString())
          .subscribe((data) => {
            this.currentUpdateListMaterial.orderDeliveryWindows = data?.data;
          });
      });
  }

  getDayNames(days: number[]): string {
    return days
      .map((day) => {
        const foundDay = this.daysList.find((d) => d.value === day);
        return foundDay ? foundDay.day : "";
      })
      .join(", ");
  }

  //exportar
  onExportButtonPressed() {
    if (!this.materialListExport.canStartTask()) return;
    const dialogRef = this.dialog.open(ExportDialogComponent, {
      data: { title: MATERIAL_LIST_TITLE },
    });
    dialogRef.afterClosed().subscribe((options: ExportOptions) => {
      if (options) {
        this.materialListExport.export(
          options.format,
          options.range,
          this.totalItems,
          this.pageSize,
          this.pageIndex,
        );
      }
    });
  }

  ngOnDestroy(): void {
    this.searchSubscription.unsubscribe();
  }
}
